/**
 * Loader d'introduction de la page d'accueil (templates/partials/home-loader.php).
 *
 * Chorégraphie :
 *   1. .is-in     — l'éléphant entre en fondu (dès le 1er frame JS)
 *   2. .is-salute — la tête se lève (salut de la trompe), après 450 ms
 *   3. .is-done   — le rideau se lève une fois la page chargée ET le
 *                   salut terminé (min 1,6 s), puis l'overlay est retiré.
 *
 * Affiché une fois par session (sessionStorage) — retour à l'accueil
 * dans le même onglet = pas de re-loader.
 */
(function () {
    'use strict';

    const loader = document.querySelector('[data-pdw-home-loader]');
    if (!loader) return;

    const SESSION_KEY = 'pdwHomeLoaderSeen';
    const MIN_DISPLAY = 1600; // entrée + salut de la trompe
    const MAX_WAIT    = 3500; // failsafe si l'event load traîne
    const lockTarget  = document.documentElement;

    // Une seule fois par session.
    try {
        if (window.sessionStorage.getItem(SESSION_KEY) === '1') {
            loader.remove();
            return;
        }
        window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
        // sessionStorage indisponible (navigation privée stricte) : on joue le loader.
    }

    lockTarget.classList.add('pdw-home-loader-lock');

    const start = (window.performance && performance.now) ? performance.now() : Date.now();
    const now   = () => ((window.performance && performance.now) ? performance.now() : Date.now());

    window.requestAnimationFrame(function () {
        loader.classList.add('is-in');
    });

    window.setTimeout(function () {
        loader.classList.add('is-salute');
    }, 450);

    let revealed = false;

    function cleanup() {
        lockTarget.classList.remove('pdw-home-loader-lock');
        loader.remove();
    }

    function reveal() {
        if (revealed) return;
        revealed = true;

        loader.classList.add('is-done');

        // transitionend bubble depuis les enfants : on ne nettoie que sur
        // la transition de l'overlay lui-même.
        loader.addEventListener('transitionend', function (event) {
            if (event.target === loader) cleanup();
        });
        window.setTimeout(cleanup, 1000); // failsafe (prefers-reduced-motion)
    }

    function scheduleReveal() {
        window.setTimeout(reveal, Math.max(0, MIN_DISPLAY - (now() - start)));
    }

    if (document.readyState === 'complete') {
        scheduleReveal();
    } else {
        window.addEventListener('load', scheduleReveal, { once: true });
    }

    window.setTimeout(reveal, MAX_WAIT);
})();
